import { BookingState } from './booking/booking.state';
import { ClientDetailsState } from './client-details/client-details.state';
import { ClientsState } from './clients/clients.state';
import { CollectedServicesState } from './collected-services/collected-services.state';
import { TranslationsState } from './translations/translations.state';
import { UserState } from './user/user.state';

export const STATE_MODULES = [
  TranslationsState,
  UserState,
  CollectedServicesState,
  ClientsState,
  ClientDetailsState,
  BookingState,
];
